import { createContext } from 'react';

import type { WidgetAnimationContextType } from '@/features/dashboard/state/WidgetAnimation/types';

export const WidgetAnimationContext = createContext<WidgetAnimationContextType | null>(null);
